export default __webpack_public_path__ + "static/media/availableIcon.d665956c.svg";